/// <amd-module name="Repos/Views/Settings/Options/Components/SearchableBranchesTable" />
import React = require("react");
import * as Resources from "Repos/Views/Settings/Options/Resources";
import { IReadonlyObservableArray, IReadonlyObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Icon, IconSize } from "VSSUI/Icon";
import { Pill, PillSize } from "VSSUI/Pill";
import { PillGroup, PillGroupOverflow } from "VSSUI/PillGroup";
import { ITableColumn, SimpleTableCell, Table, TableColumnLayout } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { IBranch } from "../Contracts/Contracts";

interface ISearchableBranchesTableProps {
    data: IReadonlyObservableArray<IBranch | IReadonlyObservableValue<IBranch | undefined>>;
    onRemoveClick: (ref: IBranch) => void;
}

export class SearchableBranchesTable extends VssComponent<ISearchableBranchesTableProps, {}> {
    private columns: ITableColumn<{}>[];

    public constructor(props: ISearchableBranchesTableProps, context: IVssComponentContext) {
        super(props, context);

        this.columns = this.getColumns();
    }

    public render = (): JSX.Element => {
        return (
            <Table<IBranch>
                ariaLabel={Resources.BranchCardName}
                columns={this.columns}
                itemProvider={this.props.data}
                role="table"
                showHeader={false}
                className={"setting-branches-addtional-data"}
            />
        );
    };

    private getColumns = (): ITableColumn<{}>[] => {
        return [
            {
                columnLayout: TableColumnLayout.singleLinePrefix,
                id: "name",
                name: Resources.BranchTableNameColumn,
                readonly: true,
                renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IBranch>, tableItem: IBranch) => {
                    return (
                        <SimpleTableCell columnIndex={columnIndex} key={tableItem.ref} tableColumn={tableColumn}>
                            <Icon iconName={"OpenSource"} ariaLabel={Resources.Branch} className={"icon-margin"} />
                            <Tooltip text={tableItem.name}>
                                <span className="text-ellipsis flex-self-center icon-margin">{tableItem.name}</span>
                            </Tooltip>
                            <PillGroup className={"options-branch-pill-group"} overflow={PillGroupOverflow.fade}>
                                {tableItem.isDefault && (
                                    <Pill excludeTabStop={true} size={PillSize.compact}>
                                        {Resources.DefaultBranch}
                                    </Pill>
                                )}
                            </PillGroup>
                        </SimpleTableCell>
                    );
                },
                width: -100
            },
            {
                columnLayout: TableColumnLayout.singleLinePrefix,
                id: "remove",
                name: Resources.BranchTableRemoveColumn,
                readonly: true,
                renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IBranch>, tableItem: IBranch) => {
                    return (
                        <SimpleTableCell
                            columnIndex={columnIndex}
                            key={tableItem.ref + "/remove"}
                            tableColumn={tableColumn}
                            contentClassName="bolt-table-cell-content-with-button"
                        >
                            {!tableItem.isDefault && (
                                <Button
                                    ariaLabel={Resources.RemoveBranchAria}
                                    onClick={() => this.onRemoveClick(tableItem)}
                                    subtle={true}
                                    iconProps={{
                                        iconName: "Cancel",
                                        size: IconSize.medium
                                    }}
                                    tooltipProps={{ text: Resources.RemoveBranchAria }}
                                />
                            )}
                        </SimpleTableCell>
                    );
                },
                width: 46
            }
        ];
    };

    private onRemoveClick = (item: IBranch) => {
        this.props.onRemoveClick(item);
    };
}
